/**
 * React Query hooks for meeting notes provider integrations.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiPost } from '@/lib/http/client';

interface DisconnectResponse {
  success: boolean;
  message?: string;
}

export function useFathomDisconnect(orgId: number | undefined) {
  const queryClient = useQueryClient();
  return useMutation<DisconnectResponse, Error>({
    mutationFn: () =>
      apiPost<DisconnectResponse>(
        `/api/orgs/${orgId}/integrations/meeting-notes/fathom/disconnect/`,
        {}
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['meetingSummariesSourcesStatus', orgId],
      });
    },
  });
}

export function useGranolaDisconnect(orgId: number | undefined) {
  const queryClient = useQueryClient();
  return useMutation<DisconnectResponse, Error>({
    mutationFn: () =>
      apiPost<DisconnectResponse>(
        `/api/orgs/${orgId}/integrations/meeting-notes/granola/disconnect/`,
        {}
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['meetingSummariesSourcesStatus', orgId],
      });
    },
  });
}

export function useFirefliesDisconnect(orgId: number | undefined) {
  const queryClient = useQueryClient();
  return useMutation<DisconnectResponse, Error>({
    mutationFn: () =>
      apiPost<DisconnectResponse>(
        `/api/orgs/${orgId}/integrations/meeting-notes/fireflies/disconnect/`,
        {}
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['meetingSummariesSourcesStatus', orgId],
      });
    },
  });
}
